import React, { useEffect, useState } from "react";
import { showError } from "../ui/Message";
import { pubCall } from "../utils/PubSub";
import Table from "../ui/Table";
import { centsToPrice } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";

export default function CustomerARTotal(props) {

    const { controller = "", ship_to = "", callback = () => { }, route = "" } = props;
    const [results, setResults] = useState({});

    const columns = [
        { key: "ship_to", grow: false, align: "left", title: <>ShipTo</>, width: 70, },
        { key: "name", grow: true, align: "left", title: <>Name</> },
        { key: "balance_total", grow: false, title: <>Balance</>, width: 70, render: (e) => { return centsToPrice(e) } },
        { key: "balance_0_30", grow: false, title: <>0-30</>, width: 70, render: (e) => { return centsToPrice(e) } },
        { key: "balance_31_60", grow: false, title: <>31-60</>, width: 70, render: (e) => { return centsToPrice(e) } },
        { key: "balance_61_90", grow: false, title: <>61-90</>, width: 70, render: (e) => { return centsToPrice(e) } },
        { key: "balance_91_120", grow: false, title: <>91-120</>, width: 70, render: (e) => { return centsToPrice(e) } },
        { key: "balance_121", grow: false, title: <>121+</>, width: 70, render: (e) => { return centsToPrice(e) } },
    ]

    const fetchTotals = () => {
        pubCall("account_receivable.getCustomerTotals", { ship_to: ship_to }, (_s, _r) => {
            if (_s) {
                setResults(_r);
            } else {
                showError(_r);
            }
        })
    }
    useEffect(fetchTotals, []);

    useEffect(() => {
        const cleanup = listen(controller, route, [{ key: KBD.ANY, action: callback },]);
        return cleanup;
    }, [])


    return (
        <>
            <div className="shim" /><div className="shim" />
            <div style={{ "borderTop": "1px solid var(--border-secondary)", "width": "750px" }}>
                <Table
                    grow
                    inline
                    height={"auto"}
                    offset={0}
                    current={{}}
                    columns={columns}
                    width={"auto"}
                    data={[results]}
                    row_key={"stock_id"}
                    display_only
                />
                 <div className="shim" />
                <Status type="active"><InfoIcon />Press any key to continue.</Status>
            </div>
        </>
    )
}